import type { AlertErrorHandlerFactory, AlertFactory } from '@/features/shell'
import { ModalViewModel } from '@/infra/ModalViewModel'
import { type Job } from '@/features/jobs/Job'
import type { ApplyJobCouponByCodeFn } from '@/features/jobs'
import { action, computed, observable } from 'mobx'
import { task } from 'mobx-task'

export class AddCouponDialogViewModel {
  readonly modal = new ModalViewModel({ onClose: () => this.reset() })

  @observable accessor couponCode = ''

  constructor(
    private readonly _getJob: () => Job,
    private readonly _applyJobCouponByCode: ApplyJobCouponByCodeFn,
    private readonly _newAlert: AlertFactory,
    private readonly _createAlertErrorHandler: AlertErrorHandlerFactory,
    private readonly _beforeCouponApplied: () => Promise<void>,
  ) {}

  @computed
  get job() {
    return this._getJob()
  }

  @action.bound
  reset() {
    this.couponCode = ''
    this.applyCouponAsAdmin.reset()
  }

  @action.bound
  setCouponCode(couponCode: string) {
    this.couponCode = couponCode
  }

  applyCouponAsAdmin = task.resolved(async () => {
    if (!this.couponCode) {
      return
    }

    const couponCode = this.couponCode
    await this._beforeCouponApplied()
      .then(() => this._applyJobCouponByCode(this.job.id, couponCode))
      .catch(this._createAlertErrorHandler('Applying the coupon failed'))

    this._newAlert()
      .saying(
        'Coupon applied!',
        `Coupon was applied to ${this.job.displayName}.`,
      )
      .withState('success')
      .show()

    this.modal.close()
  })
}
